/** Internal recognition grain. Keep legacy null/empty aliases, but never decode
 * display labels by splitting a delimiter that can occur inside a label. */
export function eexRecognitionCellKey(cell) {
    return JSON.stringify([cell.month, cell.book ?? "", cell.trader ?? ""]);
}
//# sourceMappingURL=eex-cell-identity.js.map